export const NATIONALITY = [
  {
    name: "Indian",
    value: 0,
  },
  {
    name: "International",
    value: 1,
  },
];
export const PAYMENT_STATUS = [
  {
    name: "All",
    value: "all",
  },

  {
    name: "Paid",
    value: "1",
  },
  {
    name: "Unpaid",
    value: "2",
  },
];
export const PATIENT_STATUS = [
  {
    name: "All",
    value: "all",
  },
  {
    name: "Draft",
    value: "1",
  },
  {
    name: "Pending Approval",
    value: "2",
  },
  {
    name: "Active",
    value: "3",
  },
  {
    name: "Expired",
    value: "4",
  },
  {
    name: "Deleted",
    value: "5",
  },
  {
    name: "Extent Approval by 1 year",
    value: "6",
  },
  {
    name: "Draft Deleted",
    value: "7",
  },
  {
    name: "Transfer Draft",
    value: "8",
  },
  {
    name: "Transfer Pending",
    value: "9",
  },
  {
    name: "Inactive",
    value: "10",
  },
  {
    name: "Inactive to Active Pending",
    value: "11",
  },
  {
    name: "Document Verified",
    value: "12",
  },
  {
    name: "Organ Allocated",
    value: "13",
  },
];
export const BE_READY_STATUS = [
  {
    name: "All",
    value: "all",
  },
  {
    name: "Active",
    value: "1",
  },
  {
    name: "Not Ready For Operation",
    value: "2",
  },
  {
    name: "Inactive",
    value: "3",
  },
];
export const PREIODS = [
  {
    name: "<3months",
    value: "1",
  },
  {
    name: "<6months",
    value: "2",
  },
  {
    name: ">6months",
    value: "3",
  },
];
export const HEPATITIS = [
  {
    name: "Current",
    value: "1",
  },
  {
    name: "Healed",
    value: "2",
  },
  {
    name: "No History",
    value: "3",
  },
];
export const HISTORY_COMPLICATIONS = [
  { name: "GI Bleed", value: "1" },
  { name: "Ascites & Complications", value: "2" },
  { name: "Hepatorenal syndrome", value: "3" },
  { name: "Hepatopulmonary syndrome", value: "4" },
  { name: "Porto pulmonary Hypertension", value: "5" },
  { name: "Hepatic Encephalopathy", value: "6" },
  { name: "Hepatocellular Carcinoma", value: "7" },
  { name: "Others", value: "8" },
];

export const CANCER_SCREENINGS = [
  {
    name: "PSA",
    value: "1",
  },
  {
    name: "PAP Smear",
    value: "2",
  },
  {
    name: "Colonoscopy",
    value: "3",
  },
  {
    name: "Endometrial Biopsy",
    value: "4",
  },
  {
    name: "Mammogram",
    value: "5",
  },
];

export const CAUSE_OF_LUNG_DISEASE = [
  {
    name: "Restrictive lung disease",
    value: "1",
  },
  {
    name: "Obstructive lung disease",
    value: "2",
  },
  {
    name: "Suppurative lung disease",
    value: "3",
  },
  {
    name: "Vascular lung disease",
    value: "4",
  },
  {
    name: "Others",
    value: "5",
  },
];

// Phase 2 - BPL Status Options
export const BPL_STATUS = [
  {
    name: "Yes",
    value: "1",
  },
  {
    name: "No",
    value: "0",
  },
  {
    name: "Not Applicable",
    value: "2",
  },
];
// Phase 2 - CM Insurance field hidden from Recipient Registration (Change 5)
// Kept exported for backward compatibility (used in common.mixins.js, recipient.print.js)
export const CM_INSURANCE_STATUS = [
  {
    name: "Approved",
    value: "1",
  },
  {
    name: "Not Applied",
    value: "2",
  },
  {
    name: "Pending Approval",
    value: "3",
  },
  {
    name: "Not Applicable",
    value: "4",
  },
];
export const INHOUSE_RANK = [
  {
    name: "All",
    value: "all",
  },
  {
    name: "Upcoming Rank",
    value: 1,
  },
  {
    name: "Final Rank",
    value: 2,
  },
];
export const PVIR_UNIT = [
  {
    name: "WU(Woods Unit)",
    value: 1,
  },
  {
    name: "Dynes.Sec.cm5",
    value: 2,
  },
];

export const ACCEPT_DECLINE = [
  {
    html: "<span class='text-success'>Accept</span>",
    value: "1",
  },
  {
    html: "<span class='text-danger'>Decline</span>",
    value: "2",
  },
];

// Phase 2 - Emergency Status for Heart/Liver/Lung organs (Change 17)
export const EMERGENCY_STATUS = [
  { name: "Normal", value: "0" },
  { name: "Emergency", value: "1" },
];

export const AADHAR_ERROR_MESSAGES = {
  "OTP Flooding error.": "You have tried too many OTP.",
  "Otp XSD Validation Failed.": "Invalid Aadhar Number.",
  "Aadhaar number does not have verified mobile.":
    "Aadhaar number does not have verified mobile number.",
};

// Phase 2 - Dynamic fee amounts from payment constants (#29)
import {
  FEE_AMOUNTS,
  getPatientRegFee,
} from "./payment.constants";

export const TRANSFER_PAYMENT_MESSAGE = `The Transfer Recipient will be active after 5 days, once the payment of Rs.${FEE_AMOUNTS.TRANSFER.toLocaleString("en-IN")} will be done. Do you want to continue the payment?`;

export function getRecipientPaymentMessage(organIds) {
  let fee = FEE_AMOUNTS.PATIENT_REG_OTHER;
  if (organIds && organIds.length > 0) {
    fee = getPatientRegFee(organIds[0].toString());
  }
  return `Note: Unique ID will be generated only after the payment of Rs.${fee.toLocaleString("en-IN")} is completed.<br/> Do you want to continue to payment?`;
}

export const RECIPIENT_PAYMENT_MESSAGE =
  "Note: Unique ID will be generated only after the payment is completed.<br/> Do you want to continue to payment?";

export function getMultiOrganPaymentMessage(organIds) {
  let fee = FEE_AMOUNTS.PATIENT_REG_OTHER;
  if (organIds && organIds.length > 0) {
    fee = getPatientRegFee(organIds[0].toString());
  }
  return `Please pay Rs.${fee.toLocaleString("en-IN")} to confirm the request for Multi Organ. Proceed to payment?`;
}

export const MULTI_ORGAN_PAYMENT_MESSAGE =
  "Please pay to confirm the request for Multi Organ. Proceed to payment?";

// Phase 2 - NRI Document Collection (US-004)
export const NRI_VISA_TYPES = [
  { name: "Medical Visa", value: "1" },
  { name: "Tourist Visa", value: "2" },
  { name: "Business Visa", value: "3" },
  { name: "Employment Visa", value: "4" },
  { name: "Other", value: "5" },
];

export const NRI_DOCUMENT_TYPES = {
  VISA: 1,
  PASSPORT: 2,
  NATIONAL_ID: 3,
  EMBASSY_CLEARANCE: 4,
};